<template>
  <div class="fill-grid-map-aside-task-container" :class="{'collapsed': isCollapsed}">
    <p class="tasks-header" @click="isCollapsed = !isCollapsed" :title="isCollapsed ? 'Expandir lista de tareas': 'Colapsar lista de tareas'">
      <span>
        <i :class="`fas ${icon}`" :style="`color: ${iconColor}`"></i> {{ title }} ({{ tasks.length }})
      </span>
      <i v-if="isCollapsed" class="collapse-tasks-icon fas fa-caret-down"></i>
      <i v-else class="collapse-tasks-icon fas fa-caret-up"></i>
    </p>
    <ul v-show="!isCollapsed" class="tasks-list">
      <li
        v-for="task in tasks"
        :key="`task-item-${idents.map(ident => task[ident]).join('-')}`"
        class="tasks-list__item"
        :class="{'active': task._id === selectedTaskId }"
        @click="() => $emit('select-task', task)"
        @dblclick="openTypist(task)"
      >
        <div class="item__content">
          <p v-for="(ident, index) in idents" :key="`ident-${ident}`" class="item__content__ident">
            <span class="item__content__ident-key">{{ identsLabels[index] }}</span>
            {{ task[ident] }}
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class FillGridMapAsideTaskList extends Vue {
  @Prop({ required: true, default: () => [] })
  tasks: any[]

  @Prop({ required: true, default: () => [] })
  idents: string[]

  @Prop({ required: true, default: () => [] })
  identsLabels: string[]

  @Prop({ required: false, default: '' })
  icon: string

  @Prop({ required: false, default: 'black' })
  iconColor: string

  @Prop({ required: true, default: 'Tareas' })
  title: string

  @Prop({ required: false, default: -1 })
  selectedTaskId: number

  @Prop({ required: false, default: false })
  collapsed: boolean

  @Inject() readonly openFillInTypistFromMap: Function

  isCollapsed: boolean = false

  created () {
    this.isCollapsed = this.collapsed
  }

  openTypist (task: any) {
    this.openFillInTypistFromMap(task)
  }
}

</script>

<style lang="scss" scoped>
.fill-grid-map-aside-task-container {
  height: max-content;
}

.tasks-header {
  position: sticky;
  top: 2.75rem;
  background-color: #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  vertical-align: middle;
  gap: 6px;
  margin: 0;
  padding: 2px 5px;
  cursor: pointer;
  user-select: none;
  z-index: 1;

  &:hover {
    background-color: #ccc;
  }

  i {
    margin-top: 2px;
  }

  .collapse-tasks-icon {
    font-size: large;
    color: #666666;
    cursor: pointer;
    user-select: none;
  }

}

.tasks-list {
  padding-left: 0;
  margin: 0;
  list-style: none;

  .tasks-list__item {
    &:hover {
      background-color: #eee;
      cursor: pointer;
    }
    &.active {
      background-color: #ddd;
    }
    .item__content {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      border-bottom: 1px solid #ccc;
      padding: 0.5rem 1rem;

      .item__content__ident {
        margin: 0;
        font-weight: bold;
        line-height: 1.25;

        .item__content__ident-key {
          display: block;
          font-size: small;
          font-weight: normal;
        }
      }
    }
  }
}
</style>
